import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import type { AssessmentTemplate } from '@app/src/types/resourceExplorer'
import { AssessmentType } from '@app/src/types/resourceExplorer'

type UseBaselineAssessmentTemplateProps = {
  enabled?: boolean
}

const useBaselineAssessmentTemplate = ({ enabled = true }: UseBaselineAssessmentTemplateProps = {}) => {
  const { items, isLoading, refetch } = useFetchCollectionWithPost<AssessmentTemplate>({
    key: FetchKey.AssessmentTemplates,
    endpoint: endpoints.assessmentTemplateCollection,
    payload: {
      filter: [
        {
          name: 'assessmentType',
          filters: [{ value: AssessmentType.BaselineAssessment, operator: Operators.EqualTo }],
        },
      ],
      include: ['sections.rules'],
      pagination: { itemsPerPage: 1, pageNumber: 1 },
    },
    options: { enabled },
  })

  return {
    baselineAssessmentTemplate: items?.[0],
    isLoading,
    refetch,
  }
}

export default useBaselineAssessmentTemplate
